export default "__VITE_ASSET__a98c79f1__"